module.exports = __webpack_public_path__ + "static/media/quality-assurance.ba769034.svg";